module.exports = __webpack_public_path__ + "img/idefoto-logo.2d2b209e.png";